import { ReactNode } from "react"
import { Info, Error as ErrorIcon, Close } from '../icons'

type validTypes = 'info' | 'info-variant' | 'error'
type validSizes = 'md' | 'lg'

const colorClasses = {
  'info': 'bg-container-info text-on-info',
  'info-variant': 'bg-surface-secondary-container border border-accents-primary-container text-on-info',
  'error': 'bg-container-error text-on-error'
}

const roundedClasses = {
  'md': 'rounded-sm',
  'lg': 'rounded-lg',
}

const paddingClasses = {
  'md': 'p-md',
  'lg': 'p-md',
}

export interface Props {
  type: validTypes,
  size?: validSizes,
  onClose?: () => void,
  children?: ReactNode,
}

const getIcon = (type: validTypes) => {
  switch(type) {
    case "info":
    case "info-variant":
      return (<Info />);
    case "error":
      return (<ErrorIcon />);
  }
}

export const Alert = (
  {
    type,
    size = 'lg',
    onClose,
    children,
  }: Props
) => {
  
  const widthClasses = 'w-full';
  const sizeClasses = `${paddingClasses[size]} ${roundedClasses[size]}`;
  
  return (
      <div className={`flex flex-row ${colorClasses[type]} ${sizeClasses} ${widthClasses} overflow-hidden`}>
        <div className="flex text-lg mr-sm h-5 w-5">{getIcon(type)}</div>
        <div className={`grow flex flex-col items-stretch font-inter text-sm [&_a]:underline [&_a]:cursor-pointer overflow-hidden`}>
            {children}
        </div>
        {!!onClose && <div className="ml-sm mt-[-2px] mr-[-2px] text-2xl">
          <div style={{ fontSize:"inherit" }} onClick={onClose} className="cursor-pointer"><Close /></div>
        </div>}
      </div>
  );
};

export default Alert;